package io.jsonize.web.domain.model

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class HistoryItem @OptIn(ExperimentalTime::class) constructor(
    val id: String,
    val title: String,
    val timestamp: Instant,
    val content: String
)
